import ShowInput from '@/components/ShowInput';
import { Button, EllipsisSpan, Form, InputNumber, Select, TimePicker } from '@maxtropy/components';
import { V2BsaControlConfigPostResponse } from '@maxtropy/intelligent-dispath-apis-v2';
import { ColumnsType } from 'antd/es/table';
import { ActionType, ActionTypeTypeDisplay, actionTypeOptions } from '../type';
import { disabledTime, timeValidator } from './utils';
import { FormInstance } from 'antd';

export interface PowerListItem {
  // id: Key;
  type: number;
  startTime: number;
  endTime: number;
  power?: number;
}

const InputItem = (index: number, bsaConfigData?: V2BsaControlConfigPostResponse, isPower?: boolean) => {
  const ruleList = [{ required: true, message: isPower ? '请输入功率' : '请输入电量' }];
  return (
    <Form.Item noStyle dependencies={['chargingAndDischargingPeriodDetail', index, 'type']}>
      {({ getFieldValue }) => {
        const configType = getFieldValue(['chargingAndDischargingPeriodDetail', index, 'type']);
        if (Number(configType) === ActionType.Charge) {
          return (
            <Form.Item
              style={{ marginBottom: 0 }}
              name={['chargingAndDischargingPeriodDetail', index, 'power']}
              rules={ruleList}
            >
              <InputNumber
                placeholder="请输入"
                style={{ width: '80%' }}
                min={1}
                max={isPower ? bsaConfigData?.maxChargePower ?? 99999999 : 99999999}
              />
            </Form.Item>
          );
        } else if (Number(configType) === ActionType.DisCharge) {
          return (
            <Form.Item
              style={{ marginBottom: 0 }}
              name={['chargingAndDischargingPeriodDetail', index, 'power']}
              rules={ruleList}
            >
              <InputNumber
                placeholder="请输入"
                style={{ width: '80%' }}
                min={1}
                max={isPower ? bsaConfigData?.maxDischargePower ?? 99999999 : 99999999}
              />
            </Form.Item>
          );
        } else {
          return (
            <Form.Item
              style={{ marginBottom: 0 }}
              name={['chargingAndDischargingPeriodDetail', index, 'power']}
              rules={ruleList}
              initialValue={0}
            >
              <InputNumber placeholder="请输入" style={{ width: '80%' }} disabled />
            </Form.Item>
          );
        }
      }}
    </Form.Item>
  );
};

// 峰谷时段-跟随电价模版 + 充放电功率-自定义
export const columnsWithFollowPrice = (
  bsaConfigData?: V2BsaControlConfigPostResponse,
  isDetail?: boolean
): ColumnsType<PowerListItem> => {
  return [
    {
      title: '动作',
      dataIndex: 'type',
      render(value, _) {
        return <EllipsisSpan value={ActionTypeTypeDisplay[value as ActionType]}></EllipsisSpan>;
      },
    },
    {
      title: '时间段',
      render(_, _record, index) {
        return (
          <Form.Item name={['chargingAndDischargingPeriodDetail', index, 'time']} style={{ marginBottom: 0 }}>
            <ShowInput />
          </Form.Item>
        );
      },
    },
    {
      title: '功率(kW)',
      dataIndex: 'power',
      // editable: true,
      render: (value, _record, index) => {
        if (isDetail) {
          return <EllipsisSpan value={value}></EllipsisSpan>;
        } else {
          return InputItem(index, bsaConfigData, true);
        }
      },
    },
  ];
};

// 峰谷时段-自定义 + 时间段颗粒度-整点/半点 + 控制-充放电功率 + 充放电功率-跟随最大功率
export const columnsWithFixedTime: ColumnsType<PowerListItem> = [
  {
    title: '动作',
    dataIndex: 'type',
    render(value, _) {
      return <EllipsisSpan value={ActionTypeTypeDisplay[value as ActionType]}></EllipsisSpan>;
    },
  },
  {
    title: '开始时间',
    dataIndex: 'startTime',
    render(value, _) {
      return <EllipsisSpan value={value}></EllipsisSpan>;
    },
  },
  {
    title: '结束时间',
    dataIndex: 'endTime',
    render(value, _) {
      return <EllipsisSpan value={value}></EllipsisSpan>;
    },
  },
];

// 峰谷时段-自定义 + 时间段颗粒度-整点/半点 + 控制-充放电功率 + 充放电功率-自定义
export const columnsWithFixedTimeAndCustomPower = (
  bsaConfigData?: V2BsaControlConfigPostResponse,
  isDetail?: boolean
): ColumnsType<PowerListItem> => [
  ...columnsWithFixedTime,
  {
    title: '功率(kW)',
    dataIndex: 'power',
    render: (value, _record, index) => {
      if (isDetail) {
        return <EllipsisSpan value={value} />;
      } else {
        return InputItem(index, bsaConfigData, true);
      }
    },
  },
];

export const columnsWithFixedTimeAndCustomEnergy = (
  bsaConfigData?: V2BsaControlConfigPostResponse,
  isDetail?: boolean
): ColumnsType<PowerListItem> => [
  ...columnsWithFixedTime,
  {
    title: '电量(kWh)',
    dataIndex: 'power',
    render: (value, _record, index) => {
      if (isDetail) {
        return <EllipsisSpan value={value} />;
      } else {
        return InputItem(index, bsaConfigData, false);
      }
    },
  },
];

export const columnsWithCustomTime: ColumnsType<PowerListItem> = [
  {
    title: '动作',
    dataIndex: 'type',
    width: 140,
    render(value, _, index) {
      return (
        <Form.Item dependencies={['chargingAndDischargingPeriodDetail', index]} noStyle>
          {({ setFieldValue }) => {
            return (
              <Form.Item
                style={{ marginBottom: 0 }}
                name={['chargingAndDischargingPeriodDetail', index, 'type']}
                rules={[{ required: true, message: '请选择' }]}
              >
                <Select
                  options={actionTypeOptions}
                  placeholder="请选择"
                  onChange={e => {
                    if (Number(e) == ActionType.StandBy) {
                      setFieldValue(['chargingAndDischargingPeriodDetail', index, 'power'], 0);
                    } else {
                      setFieldValue(['chargingAndDischargingPeriodDetail', index, 'power'], undefined);
                    }
                  }}
                />
              </Form.Item>
            );
          }}
        </Form.Item>
      );
    },
  },
  {
    title: '开始时间',
    dataIndex: 'startTime',
    width: 200,
    render(value, _, index) {
      return (
        <Form.Item dependencies={['chargingAndDischargingPeriodDetail']} noStyle>
          {({ getFieldValue }) => {
            return (
              <Form.Item
                style={{ marginBottom: 0 }}
                name={['chargingAndDischargingPeriodDetail', index, 'startTime']}
                rules={[
                  { required: true, message: '请选择' },
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      return timeValidator(value, getFieldValue, index);
                    },
                  }),
                ]}
              >
                <TimePicker
                  format="HH:mm"
                  showNow={false}
                  disabledTime={now => disabledTime(now, getFieldValue, index, true)}
                  placeholder="开始时间"
                />
              </Form.Item>
            );
          }}
        </Form.Item>
      );
    },
  },
  {
    title: '结束时间',
    dataIndex: 'endTime',
    width: 200,
    render(value, _, index) {
      return (
        <Form.Item dependencies={['chargingAndDischargingPeriodDetail']} noStyle>
          {({ getFieldValue }) => {
            return (
              <Form.Item
                style={{ marginBottom: 0 }}
                name={['chargingAndDischargingPeriodDetail', index, 'endTime']}
                rules={[
                  { required: true, message: '请选择' },
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      return timeValidator(value, getFieldValue, index);
                    },
                  }),
                ]}
              >
                <TimePicker
                  format="HH:mm"
                  disabledTime={now => disabledTime(now, getFieldValue, index, false)}
                  showNow={false}
                  placeholder="结束时间"
                />
              </Form.Item>
            );
          }}
        </Form.Item>
      );
    },
  },
];

// 时间段颗粒度-自定义 + 控制-充放电功率 + 充放电功率-自定义
export const columnsWithCustomTimeAndPower = (
  bsaConfigData?: V2BsaControlConfigPostResponse
): ColumnsType<PowerListItem> => [
  ...columnsWithCustomTime,
  {
    title: '功率(kW)',
    width: 180,
    dataIndex: 'power',
    render: (value, _record, index) => {
      return InputItem(index, bsaConfigData, true);
    },
  },
];

// 时间段颗粒度-自定义 + 控制-充放电量 + 充放电量-自定义
export const columnsWithCustomTimeAndEnergy = (
  bsaConfigData?: V2BsaControlConfigPostResponse
): ColumnsType<PowerListItem> => [
  ...columnsWithCustomTime,
  {
    title: '电量(kWh)',
    width: 180,
    dataIndex: 'power',
    render: (value, _record, index) => {
      return InputItem(index, bsaConfigData, false);
    },
  },
];

export const operateColumn = (form: FormInstance): ColumnsType<PowerListItem> => {
  return [
    {
      title: '操作',
      fixed: 'right' as 'right',
      width: 100,
      render(value, _, index) {
        return (
          <Button
            type="link"
            onClick={() => {
              const list = form.getFieldValue('chargingAndDischargingPeriodDetail');
              const newList = list.filter((_: any, listIndex: number) => index !== listIndex);
              form.setFieldValue('chargingAndDischargingPeriodDetail', newList);
            }}
          >
            删除
          </Button>
        );
      },
    },
  ];
};
